import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export default function Button({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const { theme } = useTheme();

  const baseStyles = 'inline-flex items-center justify-center rounded-lg transition-colors';
  
  const variantStyles = {
    primary: `bg-blue-600 text-white hover:bg-blue-700 ${
      theme === 'dark' ? 'hover:bg-blue-500' : ''
    }`,
    secondary: `${theme === 'dark'
      ? 'bg-gray-700 text-gray-100 hover:bg-gray-600'
      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
    }`,
    ghost: `${theme === 'dark'
      ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-800'
      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
    }`
  };

  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <button
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${className}
      `}
      {...props}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
}